import {
  FOC_TOUR_LABEL_PLANNING_P_MODEL,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import {
  focPlanningPTourNavVisible,
  type FocPlanningPTourStepDef,
} from './focPlanningPTourTypes';
import { FOC_PLANNING_P_MODEL_TOUR_HREF } from './focPlanningPTourRegistry';

export { FOC_PLANNING_P_MODEL_TOUR_HREF, focPlanningPTourNavVisible };

export const FOC_PLANNING_P_MODEL_TOUR_STEPS: FocPlanningPTourStepDef[] = [
  {
    id: 'sectionIntro',
    phaseIndex: 0,
    title: '10.1 Planning P Operating Model',
    description:
      'PRATUS supports the full Coast Guard Incident Action Planning Process and recurring Planning P cycle. The platform supports work before, during, and after Planning P meetings — not a series of static agendas or stand-alone forms.',
  },
  {
    id: 'cycleStem',
    phaseIndex: 0,
    tour: 'planning-stepper',
    title: 'IMH Planning P Sequence',
    description:
      'The Planning-P stepper walks the IMH rhythm: Initial IC/Unified Command Briefing and Initial Unified Command Meeting (framed in the IC/UC Objectives stem), Objectives Meeting, Command and General Staff Meeting, Prep for Tactics, Tactics Meeting, Prep for Planning Meeting, Planning Meeting, IAP Preparation and Approval, Operations Brief, execution and assessment, and transition to the next operational period.',
  },
  {
    id: 'objectivesPhase',
    phaseIndex: 0,
    tour: 'planning-forms',
    title: 'Objectives and Transition Stem',
    description:
      'Phase IC/UC Objectives hosts the early transition meetings and the Initial Objectives Meeting products. Later FOC 10.x tours deep-dive Command & General Staff, Prep for Tactics, and Tactics Meeting on their dedicated phases.',
  },
  {
    id: 'advanceOp',
    phaseIndex: 7,
    tour: 'planning-advance-op',
    title: 'Operations Brief and Next Period',
    description:
      'On Operations Briefing, Advance Operational Period closes the cycle and transitions into the next operational period after IAP preparation, approval, and the operations brief.',
  },
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_PLANNING_P_MODEL),
  },
];

export function focPlanningPModelTourStepIds(): string[] {
  return FOC_PLANNING_P_MODEL_TOUR_STEPS.map((step) => step.id);
}
